
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import actions from "../js/actions.js";
import $$ from "Dom7";
import URLS from "../js/Urls.js";
var filters = {
  All: true,
  Unaswered: false,
  Sent: false,
  InHouse: false,
  Snoozed: false,
  Archived: false,
  Solved: false
};
export default {
  data: function () {
    return {
      convos: [],
      allConvos: [],
      loginobject: {},
      searchQuary: "",
      ReplyConvID: ""
    };
  },
  methods: {
    setFilters: function (name) {
      if (name == "Unaswered") {
        filters.Unaswered = !filters.Unaswered;
        filters.All = false;
        filters.Snoozed = false;
        filters.Archived = false;
        filters.Solved = false;
      } else if (name == "Sent") {
        filters.Sent = !filters.Sent;
        filters.All = false;
        filters.Snoozed = false;
        filters.Archived = false;
        filters.Solved = false;
      } else if (name == "InHouse") {
        filters.InHouse = !filters.InHouse;
        filters.All = false;
        filters.Snoozed = false;
        filters.Archived = false;
        filters.Solved = false;
      } else if (name == "All") {
        filters.All = true;
        filters.Unaswered = false;
        filters.Sent = false;
        filters.InHouse = false;
        filters.Snoozed = false;
        filters.Archived = false;
        filters.Solved = false;
      } else if (name == "Snoozed") {
        filters.Snoozed = !filters.Snoozed;
        filters.All = false;
        filters.Unaswered = false;
        filters.Sent = false;
        filters.InHouse = false;
        filters.Archived = false;
        filters.Solved = false;
      } else if (name == "Archived") {
        filters.Archived = !filters.Archived;
        filters.Snoozed = false;
        filters.All = false;
        filters.Unaswered = false;
        filters.Sent = false;
        filters.InHouse = false;
        filters.Solved = false;
      } else if (name == "Solved") {
        filters.Solved = !filters.Solved;
        filters.Snoozed = false;
        filters.All = false;
        filters.Unaswered = false;
        filters.Sent = false;
        filters.InHouse = false;
        filters.Archived = false;
      }

      let checkIfOne = false;

      for (let key in filters) {
        if (filters[key] == true) {
          checkIfOne = true;
        }
      }

      if (!checkIfOne) {
        filters.All = true;
        filters.Unaswered = false;
        filters.Sent = false;
        filters.InHouse = false;
        filters.Snoozed = false;
        filters.Archived = false;
        filters.Solved = false;
      }

      this.applyFilters();
    },
    displayFilters: function () {
      filters?.Unaswered ? $$("#UnasweredFilter").addClass("selected-filter") : $$("#UnasweredFilter").removeClass("selected-filter");
      filters?.Sent ? $$("#SentFilter").addClass("selected-filter") : $$("#SentFilter").removeClass("selected-filter");
      filters?.InHouse ? $$("#InHouseFilter").addClass("selected-filter") : $$("#InHouseFilter").removeClass("selected-filter");
      filters?.All ? $$("#AllFilter").addClass("selected-filter") : $$("#AllFilter").removeClass("selected-filter");
      filters?.Snoozed ? $$("#SnoozedFilter").addClass("selected-filter") : $$("#SnoozedFilter").removeClass("selected-filter");
      filters?.Archived ? $$("#ArchivedFilter").addClass("selected-filter") : $$("#ArchivedFilter").removeClass("selected-filter");
      filters?.Solved ? $$("#SolvedFilter").addClass("selected-filter") : $$("#SolvedFilter").removeClass("selected-filter");
    },
    applyFilters: function () {
      let filteredConvos = [];

      if (filters?.All) {
        filteredConvos = this.allConvos;
      }

      if (filters?.Unaswered) {
        filteredConvos = this.allConvos.filter(convo => !convo.IsNew);
      }

      if (filters?.Sent) {
        filteredConvos = this.allConvos.filter(convo => convo.isFromProperty);
      }

      if (filters?.InHouse) {
        filteredConvos = this.allConvos.filter(convo => convo.isInhouse);
      }

      if (filters?.Snoozed) {
        filteredConvos = this.allConvos.filter(convo => convo.isSnoozed);
      }

      if (filters?.Archived) {
        filteredConvos = this.allConvos.filter(convo => convo.isArchived);
      }

      if (filters?.Solved) {
        filteredConvos = this.allConvos.filter(convo => convo.isSolved);
      }

      if (this.searchQuary) {
        const query = this.searchQuary.toLowerCase();
        filteredConvos = filteredConvos.filter(convo => convo.CustomerName.toLowerCase().includes(query) || convo.Email.toLowerCase().includes(query) || convo.ResID.toLowerCase().includes(query));
      }

      this.displayFilters();
      this.$setState({
        convos: filteredConvos
      });
    },
    setSearchQuary: function () {
      this.searchQuary = $("#search-input").val();
      this.applyFilters();
    },
    openConversation: function (uID, reservationID) {
      try {
        const obj = {
          uID: uID,
          reservationID: reservationID
        };
        localStorage.setItem("converastion", JSON.stringify(obj));
        app.f7.views.main.router.navigate(`/conversations/`, {
          transition: 'f7-dive'
        });
      } catch (err) {
        console.log(err);
      }
    },

    async GetConvos() {
      try {
        app.f7.preloader.show();
        var obj = {
          PropertyID: this.loginobject?.PropertyID,
          UserID: this.loginobject?.UserID,
          isMobile: true
        };
        await app.f7.request.promise.post(URLS.GetAllConvos, {
          obj
        }).then(res => {
          this.allConvos = JSON.parse(res?.data)?.ConversationInboxs || [];
          this.convos = this.allConvos;
          this.$setState({
            allConvos: this.allConvos,
            convos: this.convos
          });
        });
      } catch (err) {
        console.log(err);
      } finally {
        this.applyFilters();
        app.f7.preloader.hide();
      }
    },

    async checkToUpdate() {
      const dt = new Date();

      const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);

      const date = `${padL(dt.getDate())}/${padL(dt.getMonth() + 1)}/${dt.getFullYear()} ${padL(dt.getHours())}:${padL(dt.getMinutes())}:${padL(dt.getSeconds())}`;
      var obj = {
        PropertyID: this.loginobject?.PropertyID,
        UserID: this.loginobject?.UserID,
        isMobile: true,
        date
      };
      await app.f7.request.promise.post(URLS.CheckCommunicatorRefreshConversations, {
        obj
      }).then(res => {
        const checkUpdate = res?.data;

        if (checkUpdate == "wrong date") {
          var toastCheckRates = app.f7.toast.create({
            text: checkUpdate,
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastCheckRates.open();
        } else {
          if (checkUpdate == "true") {
            this.GetConvos();
          }
        }
      });
    }

  },
  on: {
    pageInit: function (e, page) {
      var self = this;
      var $ = self.$;
      self.loginobject = actions.LoginGetResult();
      self.$setState({
        loginobject: self.loginobject
      });
      self.GetConvos();
      window.checkToUpdate = setInterval(function () {
        self.checkToUpdate();
      }, 10000);
    },
    pageReinit: function (e, page) {
      var self = this;
      self.GetConvos();
    },
    pageBeforeOut: function (e, page) {
      clearInterval(window.checkToUpdate);
    }
  },
  id: '8d757c5eff',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=settings><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i></a></div><div class="title sliding">Communicator</div></div></div><div class=page-content style="overflow-y: hidden;"><input class=communicator-filter-row style=width:100%; @input=setSearchQuary id=search-input autocomplete=off type=text aria-describedby="" placeholder="SEARCH INBOX" value=""><div class=converastion-cards-wrapper>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.convos, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=card @click="openConversation(';
          r += c(ctx_2.UniqueID, ctx_2);
          r += ', ';
          r += c(ctx_2.ReservationID, ctx_2);
          r += ');"><div class="card-content card-content-padding"><div class=row style="align-items: center;"><div class=col-60 style="font-weight:600;font-size: 15px;">';
          r += c(ctx_2.CustomerName, ctx_2);
          r += '</div><div class=col-10 style="display: flex;flex-direction: column;">';
          r += Template7Helpers.if.call(ctx_2, ctx_2.isUnread, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div style="padding: 5px;background: #7ed1e3;border-radius: 10px;width: 0;"></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.isFav, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div><svg viewBox="0 0 1000 1000" role=img focusable=false style="height: 12px; width: 12px; display: block; fill: rgb(255, 180, 0);"><path d="M972 380c9 28 2 50-20 67L725 619l87 280c11 39-18 75-54 75-12 0-23-4-33-12L499 790 273 962a58 58 0 0 1-78-12 50 50 0 0 1-8-51l86-278L46 447c-21-17-28-39-19-67 8-24 29-40 52-40h280l87-279c7-23 28-39 52-39 25 0 47 17 54 41l87 277h280c24 0 45 16 53 40z"></path></svg></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><div class=col-30 style="text-align: right;color: #747474;">';
          r += c(ctx_2.MessageDate, ctx_2);
          r += '</div>';
          r += '</div>';
          r += Template7Helpers.if.call(ctx_2, ctx_2.lastMessage, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=row><div class=last-message>';
              r += Template7Helpers.if.call(ctx_3, ctx_3.isFromProperty, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <span style="font-weight: 600;">You: </span>';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' <span>';
                  r += c(ctx_4.CustomerName, ctx_4);
                  r += ': </span>';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' <span class="';
              r += Template7Helpers.if.call(ctx_3, ctx_3.isUnread, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += 'fw-b';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '">';
              r += c(ctx_3.lastMessage, ctx_3);
              r += '</span></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.isInhouse, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=row><div class=ReservationStatusCom>In house reservation</div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '<div class=row><div class=col-100 style=display:flex;>Reservartion: ';
          r += c(ctx_2.ResID, ctx_2);
          r += '</div></div><div class=row><div class=col-100 style=display:flex;>';
          r += c(ctx_2.ReservationCheckinStr, ctx_2);
          r += ' - ';
          r += c(ctx_2.ReservationCheckoutStr, ctx_2);
          r += ' · ';
          r += c(ctx_2.RoomCategoryName, ctx_2);
          r += ' · ';
          r += c(ctx_2.RoomName, ctx_2);
          r += '</div></div><div class=row><div class=col-50 style=display:flex;><i class="CalIconSource SourceIcon_';
          r += c(ctx_2.channelIcon, ctx_2);
          r += '"></i>';
          r += c(ctx_2.channelName, ctx_2);
          r += '</div><div class=col-50 style="display:flex;justify-content: flex-end;">';
          r += c(ctx_2.DatetimeOfEmailStr, ctx_2);
          r += '</div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="fab fab-right-bottom floating-filters" style="position: fixed;" @click=displayFilters><a><i class="icon material-icons md-only">add</i> <i class="icon material-icons md-only">close</i></a><div class="fab-buttons fab-buttons-top"><a href="" class="fab-label-button selected-filter" @click="setFilters(\'All\')" id=AllFilter><span>All</span> </a><a href="" class=fab-label-button @click="setFilters(\'InHouse\')" id=InHouseFilter><span>In house</span> </a><a href="" class=fab-label-button @click="setFilters(\'Unaswered\')" id=UnasweredFilter><span>Unaswered</span><!-- <span class="fab-label">Action 1</span> --> </a><a href="" class=fab-label-button @click="setFilters(\'Sent\')" id=SentFilter><span>Sent</span> </a><a href="" class=fab-label-button @click="setFilters(\'Snoozed\')" id=SnoozedFilter><span>Snoozed</span> </a><a href="" class=fab-label-button @click="setFilters(\'Archived\')" id=ArchivedFilter><span>Archived</span> </a><a href="" class=fab-label-button @click="setFilters(\'Solved\')" id=SolvedFilter><span>Solved</span></a></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .converastion-cards-wrapper {
        overflow-y: auto;
        height: calc(100vh - 100px);
    }

    .fw-b {
        font-weight: 800;
    }

    .floating-filters .fab-label-button {
        padding: 0px 20px;
        text-align: center;
    }

    .floating-filters .fab-buttons-top,
    .floating-filters .fab-buttons-bottom {
        left: 50%;
        width: var(--f7-fab-button-size);
        margin-left: calc(-1 * 85px / 2);
    }

    .floating-filters .fab-buttons a {
        width: inherit;
    }

    .selected-filter {
        background-color: white !important;
        border: 1px solid black !important;
        color: black !important;
    }

    .last-message {
        text-overflow: ellipsis;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
    }

    .ReservationStatusCom {
        color: #384de1;
        background-color: #b6e1ff;
        display: flex;
        padding: 0 5px;
        border-radius: 3px;
    }

    .communicator-filter-row {
        padding: 10px 2px !important;
        border-bottom: 1px solid black;
        text-align: center;
        display: flex;
        justify-content: space-between;
    }

    .communicator-filter {
        padding: 3px 5px;
        border: 1px solid black;
        border-radius: 8px;
        width: 20%;
    }
`,
  styleScoped: false
};
    